import { render, staticRenderFns } from "./CustomColorPicker.vue?vue&type=template&id=59f37cc8&"
import script from "./CustomColorPicker.vue?vue&type=script&lang=ts&"
export * from "./CustomColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./CustomColorPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VLayout})
